module.exports = __webpack_public_path__ + "img/6A5338_1C120B_C5975F_96886C-256px.06ebd09d.png";